module.exports = __webpack_public_path__ + "img/conducktor.3f3dee33.png";